<template>
  <v-dialog v-model="dialog" max-width="600px">
    <v-card class="rounded">
      <v-form ref="form" lazy-validation @submit.prevent="submit">
        <v-card-title class="justify-center">Enviar</v-card-title>
        <v-card-text>
          <v-row>
            <v-col cols="12" class="pt-0 pb-0 d-flex">
              <v-text-field
                type="text"
                :loading="loading"
                v-model="input.email"
                label="Email"
                :rules="[rules('Email').required]"
                hide-details="auto"
              ></v-text-field>
            </v-col>
          </v-row>

          <v-row class="justify-center">
            <v-btn
              @click="dialog = false"
              color="light"
              text
              :disabled="loading"
              style="margin-top: 25px; height: 50px; width: 50px; font-size: 50px"
            >
              <font-awesome-icon
                icon="times-circle"
                :style="{ color: '#ea2222', fontSize: 50 }"
              />
            </v-btn>

            <v-btn
              type="submit"
              color="light"
              text
              :disabled="loading"
              style="margin-top: 25px; height: 50px; width: 50px; font-size: 50px"
            >
              <font-awesome-icon
                icon="check-circle"
                :style="{ color: '#11bd11', fontSize: 50 }"
              />
            </v-btn>
          </v-row>
        </v-card-text>
      </v-form>
    </v-card>
  </v-dialog>
</template>

<script>
import moment from "moment";
export default {
  data: () => ({
    operation: "ticket",
    input: {},
    details: null,
    dialog: false,
    loading: false
  }),
  methods: {
    open(details) {
      this.dialog = true;
      this.input = { ...details.company };
      this.details = { ...details };
    },
    async submit() {
      if (this.$refs.form.validate()) {
        try {
          this.loading = true;
          await this.sendEmail();
          this.showSuccessMessage("Factura enviada con exito");
          this.dialog = false;
        } catch (error) {
          console.log(error);
        } finally {
          this.loading = false;
        }
      }
    },
    rules(name) {
      return {
        required: v => !!v || `${name} es requerido`
      };
    },
    async sendEmail() {
      let payment_on = moment().toDate();

      let baseUrl = this.projectUrl;
      let color = this.colorsGeneralPrimary;
      await this.$api.admin.sendEmail({
        color: color,
        logo:
          this.settings && this.settings.icons ? this.settings.icons.logo : "",
        orders: JSON.stringify(this.details.orders),
        total: parseFloat(this.details.total_amount_order).toFixed(2),
        legal_number: this.details.legal_number,
        amountPaid: parseFloat(this.details.amount_paid_by_user).toFixed(2),
        to: this.input.email,
        date: this.dayFormat2(payment_on),
        time: this.formatTime2(payment_on),
        subject: `Recibo de su pago a ${this.projectName}`,
        footerUrls: [
          {
            text: "Cookies",
            url: `${baseUrl}/cookies`
          },
          {
            text: "Privacidad",
            url: `${baseUrl}/privacy`
          },
          {
            text: "Términos y condiciones",
            url: `${baseUrl}/terms`
          },
          {
            text: "by aiwanna pay",
            url: `https://www.aiwannapay.com/`
          }
        ],
        invoiceRequest: this.details.invoiceRequest,
        company: this.details.company,
        settings: this.settings,
        tableQR: this.details.tableQR,
        number: this.details.number,
        paymentMethod: this.details.payment_method,
        curr_language: this.$i18n.locale,
        email_trans: {
          mesa: this.$t("email.mesa") || "Mesa",
          product: this.$t("email.product") || "Producto",
          quantity: this.$t("email.quantity") || "Cantidad",
          price: this.$t("email.price") || "Precio",
          total: this.$t("email.total") || "Total de la cuenta",
          totalPaid: this.$t("email.totalPaid") || "Total Pagado",
          baseTax: this.$t("email.baseTax") || "Base imponible",
          VAT: this.$t("email.VAT") || "IVA",
          paymentMethod: this.$t("email.paymentMethod") || "Forma de pago",
          pagado: this.$t("email.pagado") || "Pagado"
        }
      });
    }
  }
};
</script>

<style></style>
